// Set Variable for VW without Scrollbars
let vw = document.body.clientWidth  * 0.01;

let setVWSize = () => {
  let vw = document.body.clientWidth  * 0.01;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}


document.addEventListener('DOMContentLoaded', setVWSize);
window.addEventListener('resize', setVWSize);

document.addEventListener('DOMContentLoaded', () => {
  const headerbar = document.querySelector('.headerbar');
  const modMenu = document.querySelector('.mod-menu');
  const firstLevelList = document.querySelector('ul.level-1');

  const updateMenuHeight = (height) => {
    document.documentElement.style.setProperty('--active-sublist-height', `${height}px`);
  };

  const resetStyles = () => {
    document.documentElement.style.setProperty('--active-sublist-height', `${firstLevelList.scrollHeight}px`);
    document.querySelectorAll('.expanded').forEach(el => el.classList.remove('expanded'));
    document.querySelectorAll('ul.mod-menu').forEach(ul => {
      ul.classList.remove(...Array.from(ul.classList).filter(cls => cls.startsWith('activelevel-')));
    });
  };

  const handleMenuClick = (event) => {
    if (window.innerWidth >= 1200) {
      resetStyles();
      return;
    }

    const target = event.target;
    const ul = target.closest('ul');
    const level = Array.from(ul.classList).find(cls => cls.startsWith('level-'));

    if (target.closest('.parent') && level === 'level-1') {
      const levelNumber = parseInt(level.split('-')[1], 10);
      if (levelNumber <= 2) {
        ul.classList.add(`activelevel-${levelNumber + 1}`);
        target.classList.add('expanded');
        const sublist = target.nextElementSibling;
        if (sublist) {
          updateMenuHeight(sublist.scrollHeight);
        }
        if (levelNumber + 1 === 2) {
          ul.classList.remove('activelevel-1');
        }
      }
    }

    if (target.closest('.back-button')) {
      const parentUl = target.closest('ul');
      const parentLevel = Array.from(parentUl.classList).find(cls => cls.startsWith('level-'));
      if (parentLevel) {
        const parentLevelNumber = parseInt(parentLevel.split('-')[1], 10);
        if (parentLevelNumber > 1) {
          document.querySelector('ul.mod-menu').classList.remove(`activelevel-${parentLevelNumber}`);
          document.querySelector('ul.mod-menu').classList.add(`activelevel-${parentLevelNumber - 1}`);
          document.querySelectorAll('.expanded').forEach(el => el.classList.remove('expanded'));
          updateMenuHeight(firstLevelList.clientHeight);
        }
      }
    }

    if (!document.querySelector('.expanded')) {
      updateMenuHeight(firstLevelList.clientHeight);
    }
  };

  const checkSubMenu = () => {
    if (document.querySelector('.mod-menu ul.show-menu')) {
      document.body.classList.add('body--activesubnav');
    } else {
      document.body.classList.remove('body--activesubnav');
    }
  };

  const handleMouseOver = () => {
    if (window.innerWidth >= 992) {
      checkSubMenu();
    }
  };

  const handleMouseOut = () => {
    if (window.innerWidth >= 992) {
      checkSubMenu();
    }
  };

  const handleScroll = () => {
    if (window.scrollY > 0) {
      headerbar.classList.add('headerbar--scrolled');
      if (document.body.classList.contains('header-inverted')) {
        document.body.classList.remove('inverted');
      }
    } else {
      headerbar.classList.remove('headerbar--scrolled');
      if (document.body.classList.contains('header-inverted')) {
        document.body.classList.add('inverted');
      }
    }
  };

  document.querySelector('.headerbar__navtoggler').addEventListener('click', () => {
    document.body.classList.toggle('body--activenav');
  });

  if (window.innerWidth < 1200) {
    modMenu.addEventListener('click', handleMenuClick);
    updateMenuHeight(firstLevelList.clientHeight);
  }

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 1200) {
      resetStyles();
      modMenu.removeEventListener('click', handleMenuClick);
    } else {
      modMenu.addEventListener('click', handleMenuClick);
      updateMenuHeight(firstLevelList.clientHeight);
    }
  });

  modMenu.addEventListener('mouseover', handleMouseOver);
  modMenu.addEventListener('mouseout', handleMouseOut);
  window.addEventListener('scroll', handleScroll);

  updateMenuHeight(firstLevelList.clientHeight);

  const marqueeText = document.querySelector('.footer__marquee .marquee__text');

  marqueeText.addEventListener('mouseover', () => {
    marqueeText.style.animationPlayState = 'paused';
  });

  marqueeText.addEventListener('mouseout', () => {
    marqueeText.style.animationPlayState = 'running';
  });

  const firstLayerParents = document.querySelectorAll('.headerbar__nav > .mod-menu > .parent');

  firstLayerParents.forEach(parent => {
    parent.addEventListener('focusin', (event) => {
      const sublist = parent.querySelector('ul');
      if (sublist) {
        sublist.classList.add('show-menu');
        document.body.classList.add('body--activesubnav');
        parent.setAttribute('aria-expanded', 'true');
        sublist.setAttribute('aria-hidden', 'false');
      }
    });

    parent.addEventListener('focusout', (event) => {
      const sublist = parent.querySelector('ul');
      if (sublist) {
        sublist.classList.remove('show-menu');
        document.body.classList.remove('body--activesubnav');
        parent.setAttribute('aria-expanded', 'false');
        sublist.setAttribute('aria-hidden', 'true');
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const marquees = document.querySelectorAll('.marquee__wrapper');

  marquees.forEach(marquee => {
    const marqueeTexts = marquee.querySelectorAll('.marquee__text');

    marqueeTexts.forEach(marqueeText => {

      const marqueeTextLink = marqueeText.querySelector('.marquee__text-link');

      marqueeText.addEventListener('mouseover', (event) => {
        updateLinkPosition(event, marqueeTextLink, marqueeText);
      });

      marqueeText.addEventListener('mousemove', (event) => {
        updateLinkPosition(event, marqueeTextLink, marqueeText);
      });
    });

    const updateLinkPosition = (event, linkElement, marqueeText) => {
      const rect = marqueeText.getBoundingClientRect();
      const offsetX = event.clientX - rect.left;
      const offsetY = event.clientY - rect.top;
      linkElement.style.left = `${offsetX}px`;
      linkElement.style.top = `${offsetY}px`;
    };
  });
});

// Particles

if(document.getElementById('particles-js')) {

  particlesJS('particles-js',

    {
      "particles": {
        "number": {
          "value": 100,
          "density": {
            "enable": true,
            "value_area": 900
          }
        },
        "color": {
          "value": "#ffffff"
        },
        "shape": {
          "type": "star",
          "stroke": {
            "width": 0,
            "color": "#1a1a1a"
          },
          "polygon": {
            "nb_sides": 4
          },
          "image": {
            "src": "img/github.svg",
            "width": 100,
            "height": 100
          }
        },
        "opacity": {
          "value": 0.05,
          "random": true,
          "anim": {
            "enable": true,
            "speed": 1,
            "opacity_min": 0.1,
            "sync": false
          }
        },
        "size": {
          "value": 3,
          "random": true,
          "anim": {
            "enable": false,
            "speed": 40,
            "size_min": 0.1,
            "sync": false
          }
        },
        "line_linked": {
          "enable": true,
          "distance": 192.40944730386272,
          "color": "#ffffff",
          "opacity": 0.4,
          "width": 1
        },
        "move": {
          "enable": true,
          "speed": 1.3,
          "direction": "bottom-right",
          "random": true,
          "straight": false,
          "out_mode": "out",
          "bounce": false,
          "attract": {
            "enable": true,
            "rotateX": 8017.060304327614,
            "rotateY": 5932.624625202434
          }
        }
      },
      "interactivity": {
        "detect_on": "window",
        "events": {
          "onhover": {
            "enable": true,
            "mode": "grab"
          },
          "onclick": {
            "enable": false,
            "mode": "push"
          },
          "resize": true
        },
        "modes": {
          "grab": {
            "distance": 304.52895461300443,
            "line_linked": {
              "opacity": 0.3561858966575193
            }
          },
          "bubble": {
            "distance": 400,
            "size": 40,
            "duration": 2,
            "opacity": 8,
            "speed": 3
          },
          "repulse": {
            "distance": 200,
            "duration": 0.4
          },
          "push": {
            "particles_nb": 3
          },
          "remove": {
            "particles_nb": 6
          }
        }
      },
      "retina_detect": true
    }

  );
}

// Image Scrollcrop

document.addEventListener('DOMContentLoaded', () => {
  // Wrap all images and videos with the class "scrollcrop" in a div with the class "scrollcropcontainer"
  document.querySelectorAll('.scrollcrop').forEach(element => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('scrollcropcontainer');
    element.parentNode.insertBefore(wrapper, element);
    wrapper.appendChild(element);
  });

  // Function to update the translateY value on scroll
  const updateScrollCrop = () => {
    document.querySelectorAll('.scrollcrop').forEach(element => {
      const rect = element.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const translateValue = 11; // Adjust this value as needed

      // Calculate the translateY value based on the element's position in the viewport
      const translateY = ((rect.top / viewportHeight) * translateValue) - (translateValue / 2);
      element.style.transform = `translateY(${translateY}%) scale(1.3)`;
    });
  };

  // Initial call to set the translateY values
  updateScrollCrop();

  // Update translateY values on scroll
  window.addEventListener('scroll', updateScrollCrop);
});


// Initiate Parallax

pureParallax({
  minWidth: 48
});

// Dynamic Screen Section

document.addEventListener('scroll', () => {
  const sections = document.querySelectorAll('.dynamicscreensection');
  sections.forEach(section => {
    const rect = section.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      const scrollPercent = (rect.top / window.innerHeight) * 100;
      const translateY = scrollPercent * 0.075;
      section.querySelectorAll('.dynamicscreensection__image').forEach((child, index) => {
        child.style.transform = `rotate(8deg) translateY(${index % 2 === 0 ? translateY : -translateY}%)`;
      });
    }
  });
});